import { useState,useEffect } from "react";
import useWebSocket from "../hooks/useWebSocket_old";
import TechOathCard from "../page_components/notary/techoath_card";
import TechOathTable from "../page_components/notary/techoath_table";
import LoadingAnimation from "../components/Loading";



import useUpdate from "../hooks/useUpdate";
import TechOathTableAccepted from "../page_components/notary/techoath_table_accepted";

const TechOath_old = () => {


  const [oldData, setOldData] = useState([]);
 

  const { notifications, count, sendNotification, data:wsData } = useWebSocket(
    `wss://364w6i1tn5.execute-api.ap-southeast-1.amazonaws.com/dev/?user_profile_id=ggkudasaiOWEMSI`
  );


  const API_URL = process.env.REACT_APP_API_URL;
  const fetchOldData = async () => {
    try {
      const response = await fetch(`${API_URL}/transactions/`);
      const initialData = await response.json();
      setOldData(initialData.results);
    } catch (error) {
      console.error('Error fetching old data:', error);
    }
  };

  useEffect(() => {
    fetchOldData();
  }, [API_URL]);


  const mergedData = [...oldData, ...wsData].slice(0, 20);



  const [input, setInput] = useState("");

  const handleSend = (transaction_id) => {
    //sendNotification("sendAllTransaction", transaction_id);
    setInput("");
  };


  const { updateData, isLoading, errorMessage, successMessage } = useUpdate();

  
  const [transactionId,setTransactionId] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
}


 


  return (

    <div className="container-xxl flex-grow-1 container-p-y">
      <h4 className="py-3 mb-4"><span className="text-muted fw-light">Transactions</span></h4>
      {/* <TechOathCard /> */}


      {/* <div className="row">
        <div className="col-md-8">
          <TechOathTable sendNotification={sendNotification}  />

        </div>
        <div className="col-md-4">
          <TechOathTableAccepted sendNotification={sendNotification} />
        </div>
      </div> */}




<div className="col-md-8">
          <TechOathTable sendNotification={sendNotification}  />

        </div>


      {/* <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
      />
      <button onClick={handleSend}>Send</button>
      <h2>Notifications:</h2>
      <ul>
        {notifications.map((notification, index) => (
          <li key={index}>{notification}</li>
        ))}
      </ul> */}
      
      {/* <h2>Data:</h2>
      <ul>
        {data.map((item, index) => (
          <li key={index}>{JSON.stringify(item)}</li>
        ))}
      </ul> */}





      <ul>
        {mergedData.map((transaction) => (
          <li key={transaction.transaction_id}>
            <strong>ID:</strong> {transaction.transaction_id} <br />
            <strong>Status:</strong> {transaction.transaction_status} <br />
            <strong>Amount:</strong> {transaction.user_profile} <br />
            <strong>Timestamp:</strong> {new Date(transaction.date_created).toLocaleTimeString()}
          </li>
        ))}
      </ul>
      <div>
        <h2>Notifications ({count})</h2>
        <ul>
          {notifications.map((notification, index) => (
            <li key={index}>{notification}</li>
          ))}
        </ul>
      </div>







    </div>
  );
};

export default TechOath_old;